import Config from '../../config';
import Form from '../../view/form';
import RefBooksList from './refbooks.list';
import Model from '../../model/model';
import Status from '../../model/status';
import Statuses from '../../collection/statuses';

import { ask, } from '../../utils/popups';
import { restrict } from '../../model/actions';
import { roleA, roleC, roleAC, roleAI, } from '../../roles';
import { pst } from '../../http/api';





const FilterModel = Model.extend( { defaults: {
    cluster: undefined,
} } )

export default RefBooksList.extend( { 

    initialize(options = {}) {
        options.dragMode = undefined !== options.dragMode
            ? options.dragMode
            : false;

        RefBooksList.prototype.initialize.call( this, options );
    },

    template: 'module/refbooks/statuses.list',

    url() {
        return 'statuses';
    },

    open() {
        const form = new Form( {
            template: 'module/refbooks/statuses.form',
            clusters: this.options.clusters
                .toJSON()
                .filter( cluster => cluster.isolated ),

            events: {

                'click [name="visible"]'({ currentTarget: { checked } }) {
                    this.$( '[name="defaults"]' )[0].disabled = !checked;
                    this.$( '[name="closed"]' )[0].disabled = !checked;
                },

                'click [name="defaults"]'({ currentTarget: { checked } }) {
                    this.$( '[name="visible"]' )[0].disabled = checked;
                }

            }
        } );

        const checkPermissions = () => {
            if (this.options.dragMode)
                return false;
            
            const cluster = this.currentCluster();
            if (!cluster)
                return roleA.includes( Config.role() );

            if (cluster.id == -1)
                return roleA.includes( Config.role() );

            if (!cluster.isolated)
                return roleA.includes( Config.role() );

            return true;
        };

        const actions = this.options.actions = {
            
            defaults: 'edit',
            
            create: restrict( roleAC, 

                checkPermissions,
                
                () => {
                    const current = new Status();
                    const binding = form.bind( current );
                    binding.then( () => {
                        const cluster = this.currentCluster();
                        if (cluster && cluster.id != -1 && cluster.isolated)
                            current.set( { cluster } );
                        else if (~roleC.indexOf( Config.role() )) {
                            current.set( { cluster: Config.cluster() } );
                        } 
                    } );

                    ask( binding,
                        'status::modal new - title', 'actions::create', 'actions::cancel', 
                        () => this.options.statuses.save( form )
                            /*.then( () => current.get( 'default' )
                                ? this.options.statuses.fetch()
                                : undefined )*/ )

                            .then( () => this.options.source.reset(
                                this.options.statuses.models,
                                { silent: true } // a sort of paranoia
                            ) )
                            .then( () => this.sort() )
                            .then( () => this.render() );
                } ),
            
            edit: restrict( roleAC, 

                checkPermissions,
                
                original => {
                    const current = original.clone();
                    const isDefault = original.get( 'default' );
                    ask( form.bind( current ),
                        'status::modal edit - title', 'actions::save', 'actions::cancel', 

                        () => this.options.source.save( form )
                            .then( () => current.get( 'default' ) != isDefault
                                ? this.options.statuses.fetch()
                                : undefined ) )

                            .then( () => this.options.source.reset(
                                this.options.statuses.models,
                                { silent: true } // a sort of paranoia
                            ) )
                            .then( () => this.sort() )
                            .then( () => this.render() );
                } ),
            
            destroy: restrict( roleAC, 
                
                checkPermissions,
                
                current => {
                    const { page } = this.state();
                    // length will be updated by "destroy" call on model
                    const length = this.options.paged.length;

                    ask( 'status::modal delete - confirmation text',
                        'status::modal delete - title', 'actions::yes', 'actions::no',
                        () => this.options.source.destroy( current ) )
                        .then( () => {
                            if (length === 1 && page > 1)
                                    this.setState( { page: page - 1, } );
                        } )
                        .then( () => this.sort() )
                        .then( () => this.render() )
                        .then( () => this.navigated() ) 
                } ),

            sort: restrict( roleAC, 
                
                () => checkPermissions(),

                () => { 
                    const { cluster } = this.state();
                    this.options.filter.set(
                        'sortCluster', cluster,
                        { silent: true } );

                    // set flag to force sort() take cluster from sort-filter
                    this.options.dragMode = true;
                    // need to iterate all clusters (options.source) because cluster filter
                    // may be changing during sorting process
                    this.options.source.models
                            .forEach( model => model.set( 'new-order', model.get( 'order' ) ) )
                    this.setState( { page: 1 } );
                    this.sort( { sort: 'order', direction: 'asc' } )
                        .then( () => this.render() );
                } ),

            applySort: restrict( roleAC, 

                () => this.isOrderChanged(),

                () => pst( '/statuses/sort' ).cerebellum().blocking( this )
                    .body( { 
                        ids: this.options.sorted.models
                            .map( model => [model.id, model.get( 'new-order' )] )
                            .sort( ([idA, indexA], [idB, indexB]) => indexA - indexB )
                            .map( ([id]) => id ) 
                    } )
                    .execute()
                    .then( () => this.options.sorted.models
                        .forEach( model => model.set( 'order', model.get( 'new-order' ) ) ) )
                        .then( () => this.options.dragMode = false )
                        .then( () => this.sort() )
                    .then( () => this.render() ) ),

            cancelSort: restrict( roleAC, 
                () => Promise.resolve()
                    // drop drag-mode first
                    .then( () => this.options.dragMode = false )
                    // then sort
                    .then( () => this.sort() )
                    .then( () => this.render() ) ),
        
        };

        this.options.clusterPassed = this.state().cluster;
        // there is no such option in cluster filter in Statuses list
        const hasNoClusterOption = 
            !this.options.clusterPassed ||
            this.options.clusterPassed.id == -1 && roleC.includes( Config.role() );
        this.options.clusterPicked = hasNoClusterOption
            ? this.listClusters()[0]
            : this.options.clusterPassed;
        this.setState( {
            cluster: this.options.clusterPicked
        } );

        this.options.filter = new FilterModel( { 
            cluster: this.options.clusterPicked,
        } )
        this.options.source = new Statuses( this.options.statuses.models );
        this.options.sorted = new Statuses();
        this.options.filtered = new Statuses();
        this.options.paged = new Statuses( { actions, } );

        return this.sort().then( () => this.bind( this.options.filter ) );
    },

    listClusters() {
        if (roleA.includes( Config.role() ))
            return RefBooksList.prototype.listClusters.call( this );
        
        return this.options.clusters.toJSON();
    },

    filterClusterFn(model, cluster) {
        return !model.get( 'cluster' ) && (!cluster || !cluster.isolated) ||
            model.get( 'cluster' ) && cluster && model.get( 'cluster' ).id == cluster.id;
    },

    getClusterToPass() {
        const { cluster } = this.state();
        const { clusterPassed, clusterPicked } = this.options;
        const changed = 
            !!clusterPicked !== !!cluster ||
            clusterPicked && cluster && clusterPicked.id != cluster.id;
        const changedInitially = 
            !!clusterPicked !== !!clusterPassed ||
            clusterPicked && clusterPassed && clusterPicked.id != clusterPassed.id;

        return {
            cluster: changed
                ? cluster
                : changedInitially
                    ? clusterPassed
                    : clusterPicked  
        };
    },

    // rewrite events to pass out correct cluster
    events: {

        'click .-open-types'() {
            this.trigger( this.constructor.TYPES, 
                this.getClusterToPass() );
        },

        'click .-open-type-groups'() {
            this.trigger( this.constructor.TYPEGROUPS,
                this.getClusterToPass() );
        },

        'click .-open-priorities'() {
            this.trigger( this.constructor.PRIORITIES,
                this.getClusterToPass() );
        },

        'click .-open-fields'() {
            this.trigger( this.constructor.FIELDS,
                this.getClusterToPass() );
        },

        'click .-open-stickers'() {
            this.trigger( this.constructor.STICKERS,
                this.getClusterToPass() );
        },

        'click .-open-capabilities'() {
            this.trigger( this.constructor.CAPABILITIES,
                this.getClusterToPass() );
        },

        'click .-open-servers'() {
            this.trigger( this.constructor.SERVERS,
                this.getClusterToPass() );
        },

        'click .-open-scripts'() {
            this.trigger( this.constructor.SCRIPTS,
                this.getClusterToPass() );
        },

    }

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/statuses.list.js